<div class="map" [id]="mapId"></div>
<div *ngIf="showZoomButtons" class="map__controls">
    <ion-button (click)="zoomIn()">
        <ion-icon src="../../../assets/icon/plus.svg"></ion-icon>
    </ion-button>
    <ion-button color="secondary" (click)="zoomOut()">
        <ion-icon src="../../../assets/icon/minus.svg"></ion-icon>
    </ion-button>
</div>